import React, { useEffect, useState } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'

const DESCRIPTION_ID = 'cleverpush-opt-in-desc'

function browserSupportsWebPush() {
  return typeof window !== 'undefined'
    && 'Notification' in window
    && 'serviceWorker' in navigator
}

function CleverPushOptInRow() {
  const pageConfig = usePageConfig()
  const cleverPushEnabled = Boolean(pageConfig?.cleverPushEnabled)
  const currentUserId = pageConfig?.currentUserId
  const [isSupported, setIsSupported] = useState(false)
  // In-memory only -- a reload re-shows the button on purpose.
  const [hasSubscribed, setHasSubscribed] = useState(false)

  useEffect(() => {
    if (!browserSupportsWebPush()) return
    setIsSupported(true)
  }, [])

  // Re-tag users who opted in before the user_id attribute was wired up. The
  // CleverPush queue ignores `setAttribute` for anonymous sessions, so this
  // is safe to push unconditionally once the SDK initialises. The effect
  // re-runs when `currentUserId` becomes available so late-arriving page
  // config (e.g. via the `window-config-loaded` event) is honored.
  useEffect(() => {
    if (!cleverPushEnabled || !currentUserId) return
    window.CleverPush = window.CleverPush || []
    window.CleverPush.push(['setAttribute', 'user_id', String(currentUserId)])
  }, [cleverPushEnabled, currentUserId])

  if (!cleverPushEnabled) return null
  if (!isSupported) return null
  if (hasSubscribed) return null

  // We intentionally render regardless of Notification.permission. During the
  // Iterable -> CleverPush migration, existing 'granted' permissions came from
  // the old Firebase service worker, so 'granted' does NOT imply an active
  // CleverPush subscription. For 'denied' users the click is a no-op and we
  // accept that UX gap for now -- we will revisit after observing behavior in
  // production. The CleverPush SDK handles each permission state on its end.
  const handleClick = () => {
    window.CleverPush = window.CleverPush || []
    // `triggerOptIn` invokes the callback with a subscriptionId once the user
    // has registered with CleverPush; we use it to hide the button for the
    // remainder of this page lifecycle.
    window.CleverPush.push(['triggerOptIn', (err, subscriptionId) => {
      if (err || !subscriptionId) return
      setHasSubscribed(true)
    }])
    if (currentUserId) {
      window.CleverPush.push(['setAttribute', 'user_id', String(currentUserId)])
    }
  }

  return (
    <div className="cleverpush-opt-in-row">
      <span id={DESCRIPTION_ID} className="cleverpush-opt-in-row__text cgt-body-base-semibold">
        Get notified even when you switch tabs
      </span>
      <Button
        type="secondary"
        size="tiny"
        onClick={handleClick}
        aria-describedby={DESCRIPTION_ID}
        customClass="cleverpush-opt-in-row__button"
      >
        Allow Browser Notifications
      </Button>
    </div>
  )
}

export default CleverPushOptInRow
